import React from 'react';
import PropTypes from 'prop-types';

const HamburgerButton = ({ onClick, isActive, theme }) => (
  <button
    className={`hamburger hamburger--collapse hamburger--${theme} ${isActive ? 'is-active': ''}`}
    type="button"
    onClick={onClick}
  >
    <span className="hamburger-box">
      <span className="hamburger-inner"></span>
    </span>
  </button>
);

HamburgerButton.defaultProps = {
  theme: 'light',
  isActive: false
};

HamburgerButton.propTypes = {
  theme: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

export default HamburgerButton;
